var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIconSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8544 18.7143C42.8544 29.8571 26.1401 42.8571 26.1401 42.8571C26.1401 42.8571 9.42578 29.8571 9.42578 18.7143C9.42578 9.61057 17.0364 2 26.1401 2C35.2438 2 42.8544 9.61057 42.8544 18.7143Z",
    stroke: "#3E3E3E",
    strokeWidth: 3.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1456 24.2862C27.6233 24.2862 29.0404 23.6992 30.0852 22.6543C31.1301 21.6095 31.7171 20.1924 31.7171 18.7147C31.7171 17.2371 31.1301 15.82 30.0852 14.7751C29.0404 13.7303 27.6233 13.1433 26.1456 13.1433C24.668 13.1433 23.2509 13.7303 22.2061 14.7751C21.1612 15.82 20.5742 17.2371 20.5742 18.7147C20.5742 20.1924 21.1612 21.6095 22.2061 22.6543C23.2509 23.6992 24.668 24.2862 26.1456 24.2862Z",
    stroke: "#3E3E3E",
    strokeWidth: 3.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.286 37.2855H44.7143L50.2857 50.2855H2L7.57143 37.2855H10.9997",
    stroke: "#3E3E3E",
    strokeWidth: 3.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconSvg);
export default __webpack_public_path__ + "static/media/location_icon_svg.4d334669dd46dea39b7b181bfaef8352.svg";
export { ForwardRef as ReactComponent };